import { useNavigate } from "react-router-dom";

import videoIcon from "../../../assets/icons/otherDocumentIcon.svg";
import handbookIcon from "../../../assets/icons/HandbookIcon.svg";
import presentationIcon from "../../../assets/icons/PresentationIcon.svg";

const stats = [
  {
    title: "Videos",
    count: 1200,
    subTitle: "Total Hours",
    subValue: 3000,
    icon: videoIcon,
    path: "/knowledge-management/topics",
  },
  {
    title: "Handbooks",
    count: 300,
    subTitle: "Total Pages",
    subValue: 3000,
    icon: handbookIcon,
  },
  {
    title: "Presentations",
    count: 300,
    subTitle: "Total Pages",
    subValue: 3000,
    icon: presentationIcon,
  },
];

const StatsCards = () => {
  const navigate = useNavigate();

  const handleClick = (item) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
      {stats.map((item, idx) => (
        <div
          key={idx}
          onClick={() => handleClick(item)}
          className={`
            flex items-center justify-between gap-4 p-8 rounded-xl
            bg-white dark:bg-slate-800
            shadow
           border border-white dark:border-slate-700
            ${item.path ? "cursor-pointer hover:shadow-md transition" : "hover:shadow-md transition"}
          `}
        >
          {/* LEFT ICON */}
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 flex items-center justify-center">
              <img
                src={item.icon}
                alt={item.title}
                className="w-14 h-14 object-contain "
              />
            </div>

            {/* MAIN TEXT */}
            <div>
              <p className="text-base text-slate-800 dark:text-slate-400">
                {item.title}
              </p>
              <p className="text-4xl font-semibold text-slate-900 dark:text-white leading-tight">
                {item.count}
              </p>
            </div>
          </div>

          {/* DIVIDER */}
          <div className="h-16 w-px bg-slate-300 dark:bg-slate-600" />

          {/* RIGHT TEXT */}
          <div className="text-right">
            <p className="text-base text-slate-600 dark:text-slate-400">
              {item.subTitle}
            </p>
            <p className="text-xl font-semibold text-slate-900 dark:text-white">
              {item.subValue}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;